import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import './AttendeeInterestTable.css';
export class AttendeeInterestTable extends Component {
  static contextTypes = {
    t: PropTypes.func.isRequired
  };
  static propTypes = {
    session_attendees: PropTypes.object
  };

  render() {
    const { fetching, attendees } = this.props.session_attendees;
    const { t } = this.context;

    return (
      <div>
        <div className="attendeeInterestTableLayout">
          <div className="panelHeader">
            <div className="panelTitle">{t('sessionDetails.mostInterested')}</div>
          </div>
          {!fetching && <div className="panelBody">{this.getSessionsTable(attendees)}</div>}
        </div>
      </div>
    );
  }

  getSessionsTable = attendees => {
    return (
      <ReactTable
        data={this.getAttendeeInterestData(attendees)}
        columns={this.getColumns()}
        defaultPageSize={attendees.length}
        minRows={5}
        style={{ height: '270px' }}
        showPagination={false}
        className="-highlight"
        defaultSorted={[{ id: 'interestRating', desc: true }]}
      />
    );
  };

  getColumns = () => {
    const { t } = this.context;
    return [
      {
        accessor: 'interestRating',
        Header: t('sessionDetails.interestRatingShort'),
        width: 90
      },
      {
        accessor: 'name',
        Header: t('sessionDetails.name')
      },
      {
        accessor: 'email',
        Header: t('sessionDetails.email'),
        Cell: this.emailCellFormatter
      }
    ];
  };

  getAttendeeInterestData = attendees => {
    return attendees.map(item => {
      return {
        interestRating: (item.stats && item.stats.interestRating) || 0,
        name: item.givenName + ' ' + item.surName,
        email: item.email
      };
    });
  };

  emailCellFormatter = ({ original }) => <a href={`mailto:${original.email}`}>{original.email}</a>;
}

export default connect(state => ({
  session_attendees: state.reduced_session_attendees
}))(AttendeeInterestTable);



// WEBPACK FOOTER //
// ./src/GoToWebinar/Sessions/SessionDetails/Table/AttendeeInterestTable/AttendeeInterestTable.js